exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ds-card-content{display:flex;flex-direction:column;height:100%;padding:.75rem var(--ds-grid-gap) 1rem var(--ds-grid-gap)}@media (min-width:37.5rem){.ds-card-content{padding-left:1rem;padding-right:1rem}}", ""]);

// exports
exports.locals = {
	"ds-card-content": "ds-card-content"
};